<template>
  <div>
    <v-toolbar height="48">
      <span v-text="'Your Notification'"></span>
      <v-spacer></v-spacer>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="getNotification(activeStatus)">
            <v-icon size="20" v-text="$getIcon('mdiRefresh')"></v-icon>
          </v-btn>
        </template>
        <span v-text="'Refresh your notifications'"> </span>
      </v-tooltip>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="readAllNotifications">
            <v-icon size="20" v-text="$getIcon('mdiCheck')"></v-icon>
          </v-btn>
        </template>
        <span v-text="'Mark All As Read'"> </span>
      </v-tooltip>
      <v-btn icon @click="$emit('closeDrawer')">
        <v-icon size="20" v-text="$getIcon('mdiArrowRight')"></v-icon>
      </v-btn>
    </v-toolbar>
    <v-tabs slider-color="blue" grow>
      <v-tab
        v-for="notification in notificationTabs"
        :key="notification.title"
        ripple
        class="text-capitalize px-0"
        @click="activeStatus = notification.status"
      >
        <span class="text-subtitle-2" v-text="notification.title"></span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-chip
              :color="notification.color"
              class="mx-1 px-2"
              small
              dark
              v-on="on"
              v-text="notification.count"
            ></v-chip>
          </template>
          <span>
            {{ notification.count }}
          </span>
        </v-tooltip>
      </v-tab>
    </v-tabs>
    <v-card v-if="response && response.results && response.results.length">
      <v-list dense>
        <v-list-item-group>
          <v-list-item
            ripple
            selectable
            v-for="(notification, index) in response.results"
            :key="`I-${notification.id}-${index}`"
          >
            <v-list-item-content @click="readNotifications(notification)">
              <v-row
                no-gutters
                class="text-caption pointer grey--text"
                align="center"
              >
                <v-col cols="auto">
                  <v-icon
                    v-if="activeStatus"
                    class="mr-3"
                    left
                    color="grey"
                    v-text="$getIcon('mdiEmailOutline')"
                  ></v-icon>
                  <v-icon
                    v-else
                    class="mr-3"
                    left
                    color="grey"
                    v-text="$getIcon('mdiEmailOpenOutline')"
                  ></v-icon>
                </v-col>
                <v-col cols="10">
                  <v-tooltip
                    v-if="notification.text.length > 100"
                    max-width="300"
                    top
                  >
                    <template v-slot:activator="{ on }">
                      <div v-on="on" class="subtitle-2">
                        {{ truncate(notification.text, 100) }}
                      </div>
                    </template>
                    <span>{{ notification.text }}</span>
                  </v-tooltip>
                  <div v-else class="subtitle-2 font-weight-bold">
                    {{ notification.text }}
                  </div>
                  <div
                    class="caption text--grey"
                    v-text="
                      humanizeTime(notification.notify_on) === 'Just Now'
                        ? 'Just Now'
                        : humanizeTime(notification.notify_on)
                    "
                  ></div>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      response: {},
      notificationTabs: [
        {
          title: "Unread",
          color: "blue",
          count: 0,
          status: true
        },
        {
          title: "Read",
          color: "green",
          count: 0,
          status: false
        },
        {
          title: "All",
          color: "orange",
          count: 0,
          status: ""
        }
      ],
      refresh: false,
      activeStatus: true,
      markAllAsRead: false
    };
  },
  mounted() {
    this.getNotification(this.activeStatus);
  },
  methods: {
    getNotification(unread) {
      const endpoint = `/api/v1/notification/?unread=${unread}`;
      this.$axios.$get(endpoint).then(response => {
        this.response = response;
        this.setCount(response);
        this.$emit("refreshNotification", response.unread_count);
      });
    },
    humanizeTime(timeStamp) {
      return this.$dayjs(timeStamp).fromNow();
    },
    readAllNotifications() {
      const endpoint = "/api/v1/notification/read-all/";
      this.$axios.$post(endpoint).then(() => {
        this.getNotification(this.activeStatus);
      });
    },
    readNotifications(item) {
      if (this.activeStatus) {
        const endpoint = `/api/v1/notification/${item.id}/read/`;
        this.$axios.$post(endpoint).then(() => {
          this.getNotification(this.activeStatus);
        });
        this.$emit("refreshNotification", this.response.unread_count - 1);
      }
      this.redirectNotification(item);
    },
    redirectNotification(item) {
      const mapper = {
        "Communication Log Reminder": {
          path: "activity-logs",
          query: { client: item?.interactive_data?.client?.slug }
        },
        "New Client Notification": {
          path: "clients-clientslug",
          params: { clientSlug: item?.interactive_data?.client?.slug }
        }
      };
      this.$router.push({
        name: mapper[item.interactive_type].path,
        query: mapper[item.interactive_type].query || {},
        params: mapper[item.interactive_type].params || {}
      });
    },
    setCount(response) {
      this.notificationTabs[0].count = response.unread_count;
      this.notificationTabs[1].count = response.read_count;
      this.notificationTabs[2].count = response.total_count;
    },
    truncate(text, length, suffix) {
      if (!text) return "";
      let truncatedText = "";
      suffix = suffix || "...";
      if (text.length > length) {
        truncatedText = text.substring(0, length) + suffix;
      } else {
        truncatedText = text.substring(0, length);
      }
      return truncatedText;
    }
  },
  watch: {
    activeStatus(val) {
      this.getNotification(val);
    }
  }
};
</script>
